import { CardHeader, CardTitle } from '@/components/ui/card';

export interface HeaderProps {
  title: string;
  subTitle?: string;
}

export const CampaignCreationCardHeader = ({ title, subTitle = '' }: HeaderProps) => {
  return (
    <CardHeader>
      <CardTitle className='text-[20px] font-semibold'> {title}</CardTitle>
      {subTitle !== '' && <p className='text-base text-slate-900'>{subTitle}</p>}
    </CardHeader>
  );
};
